import { readFileSync, writeFileSync } from 'node:fs';
import handlebars from 'handlebars';
import { IGeneratorOptions } from '../models/generator-options.ts';

export abstract class BaseGenerator<TContextSchema> {
  public abstract readonly GeneratorName: string;
  public readonly template?: handlebars.TemplateDelegate<TContextSchema>;
  public readonly emptyArrayRegex = /, ]/g;
  public constructor(
    public readonly generatorOptions: IGeneratorOptions,
    public readonly templateFilePath: string | undefined,
  ) {
    if (templateFilePath) {
      const templateSource = readFileSync(templateFilePath, { encoding: 'utf8' });
      this.template = handlebars.compile<TContextSchema>(templateSource);
    }
  }

  protected generateFile(outputFilePath: string, context: TContextSchema | null): string | null {
    if (!this.template) {
      this.generatorOptions.logger?.warn(`Template for ${this.GeneratorName} has not been specified.`);
    } else if (!context) {
      this.generatorOptions.logger?.warn(`Context for ${this.GeneratorName} has not been provided.`);
    } else {
      try {
        const content = this.template(context).replace(this.emptyArrayRegex, ']');
        writeFileSync(outputFilePath, content, { encoding: 'utf8' });
        return content;
      } catch (err) {
        this.generatorOptions.logger?.error(`Error executing template: ${this.templateFilePath ?? 'undefined'}.`);
        this.generatorOptions.logger?.error(`This is likely an issue with the template.`);
        this.generatorOptions.logger?.error(`Data: ${JSON.stringify(context)}`);
        this.generatorOptions.logger?.error(`Goto: https://github.com/ikemtz/openapi-ts-generator to report an issue if necessary.`);
        this.generatorOptions.logger?.error(JSON.stringify(err));
        throw err;
      }
    }
    return null;
  }
}
